import { batch } from 'react-redux';

import { DataLakeEnums } from 'dashboard-services/api/dataLake';
import { ActionService } from 'dashboard-services/services';
import { DashboardLinkFactory } from 'ng-common-features/urlBuilder';
import { globalActions, guardedDeleteActions } from 'primary-components';

import { settingsMyAccountActions } from 'actions/modules/myAccount';
import { statusesActions } from 'actions/modules/statuses';
import { routing } from 'routing';

import { groupDialogDatalakeActions } from './';

export default (() => {  
  const CURRENT_GROUP_PREFIX = "CURRENT_GROUP_"

  const EMPTY_FIELD = {
    name: "",
    type: DataLakeEnums.GROUP_FIELD_TYPE.TEXT,
    defaultValue: ""
  }

  const ON_CHANGE = 'ON_CHANGE_DL_GROUPS'
  const onChange = ActionService.makeActionCreator(ON_CHANGE, 'value', 'name')

  const removeGroup = ({ groupName, onRemoveGroup, onSuccess, tags = [] }) => dispatch => {
    const onDelete = () => 
      onRemoveGroup().then(() => {
        onSuccess?.()
        dispatch(globalActions.getMessageStore()).success(`Group ${groupName} has been deleted.`)
        dispatch(onChange(undefined, "selectedGroup"))
      })
    if(tags.findIndex(t => String(t.tagName).toLowerCase() === "prod") === -1) {
      dispatch(globalActions.getToastsStore()).info(
        `Group ${groupName} and files associated with it will be deleted immediately. You can't undo this action.`,
        "Delete group",
        {
          withCancel: false,
          confirmText: "Delete",
          confirmAction: onDelete
        }
      )
    } else {
      dispatch(guardedDeleteActions.onChange(onDelete, "onDelete"))
      dispatch(guardedDeleteActions.onChange("group", "type"))
      dispatch(guardedDeleteActions.onChange(true, "isOpen"))
    }
  }

  const showInStatuses = ({ groupName }) => dispatch => batch(() => {
    dispatch(statusesActions.changeValue(groupName, 'name'))
    dispatch(statusesActions.changeValue(statusesActions.MODES.HISTORY, 'mode'))
    dispatch(statusesActions.changeValue(true, 'open'))
  })

  const openCreateGroup = ({ canBeShared } = {}) => dispatch => dispatch(groupDialogDatalakeActions.open({ mode: groupDialogDatalakeActions.MODES.CREATE, canBeShared }))

  const openEditGroup = ({ description, fields, groupName, groupTags, canBeShared } = {}) => dispatch =>
    dispatch(groupDialogDatalakeActions.open({ mode: groupDialogDatalakeActions.MODES.EDIT, groupName, description, fields, groupTags, canBeShared }))

  const openGroupConfiguration = ({ description, fields, groupName, groupTags, owner, canBeShared } = {}) => dispatch =>
    dispatch(groupDialogDatalakeActions.open({ mode: groupDialogDatalakeActions.MODES.CONFIGURATION, groupName, description, fields, groupTags, owner, canBeShared }))


  const getFavoriteGroups = () => (_, getState) => getState().myAccountState.settingsState.favoriteGroups
  
  const addToFavorites = ({
    groupName,
    shared,
    owner,
    description,
    fields,
    groupId,
    updateSettingsCall
  }) => dispatch => {
    const favoriteGroups = dispatch(getFavoriteGroups()),
          newFavoriteGroups = favoriteGroups.add({ name: groupName, shared, owner, favorite: true, description, fields, groupId })
    dispatch(settingsMyAccountActions.changeSetting(newFavoriteGroups, 'favoriteGroups'))
    updateSettingsCall({ settings: { favoriteGroups: JSON.stringify(newFavoriteGroups) } })
  }

  const removeFromFavorites = ({ groupName, updateSettingsCall }) => dispatch => {
    const favoriteGroups = dispatch(getFavoriteGroups()),
          newFavoriteGroups = favoriteGroups.removeByProps({ name: groupName })
    dispatch(settingsMyAccountActions.changeSetting(newFavoriteGroups, 'favoriteGroups'))
    updateSettingsCall({ settings: { favoriteGroups: JSON.stringify(newFavoriteGroups) } })
  }

  const openShareGroup = ({ groupName, owner, canBeShared }) => dispatch => {
    if(!canBeShared) {
      return;
    }
    dispatch(groupDialogDatalakeActions.open({ mode: groupDialogDatalakeActions.MODES.SHARE, groupName, owner, canBeShared }))
  }

  const onTagClick = (e, { tagName, navigate, searchParams }) => {
    e.preventDefault()
    e.stopPropagation()
    searchParams.set("tags", tagName)
    const url = DashboardLinkFactory.dataLake.list({ baseUrl: "", rawQuery: searchParams.toString(), tab: routing.dataLake.routing.groups.name })
    navigate(url)
  }

  const onChangeGroupTags = ({ data, onChangeAction }) => {
    onChangeAction(data.map(tag => {
      const isTagNew = tag?.["__isNew__"] === true
      return ({ tagId: isTagNew ? undefined : tag?.value, tagName: tag?.label })
    }))
  }

  return {
    ON_CHANGE,
    onChange,
    CURRENT_GROUP_PREFIX,
    removeGroup,
    showInStatuses,
    openCreateGroup,
    openEditGroup,
    openGroupConfiguration,
    addToFavorites,
    removeFromFavorites,
    openShareGroup,
    EMPTY_FIELD,
    onTagClick,
    onChangeGroupTags
  }
})()
